import { wsDriver, getMasonryWSRootNode } from '@leagueplatform/masonry';

export const formsCenterMasonryConfig = {
  appId: 'cigna_form_center',
  screenName: 'forms center',
  productArea: 'foundation',
  apiParams: {},
};

export const FormsCenterMasonryDriver = wsDriver;
export const FormsCenterMasonryRootNode = getMasonryWSRootNode(
  formsCenterMasonryConfig,
);
